/*
 * Public API Surface of microapp
 */
export * from './lib/microapp-tariff.module';
export * from './pages/microapp-tariff.home.component';
export * from './pages/microapp-tariff.home.module';
